'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserSettings$Version() {
}
export { $c_Lapp_data_GeneralPracticeUserSettings$Version as $c_Lapp_data_GeneralPracticeUserSettings$Version };
$c_Lapp_data_GeneralPracticeUserSettings$Version.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserSettings$Version.prototype.constructor = $c_Lapp_data_GeneralPracticeUserSettings$Version;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserSettings$Version() {
}
export { $h_Lapp_data_GeneralPracticeUserSettings$Version as $h_Lapp_data_GeneralPracticeUserSettings$Version };
$h_Lapp_data_GeneralPracticeUserSettings$Version.prototype = $c_Lapp_data_GeneralPracticeUserSettings$Version.prototype;
$c_Lapp_data_GeneralPracticeUserSettings$Version.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.data.-General-Practice-User-Settings$-Version.js.map
